import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { MomoProvider, Wallet } from '@/repositories/wallet-repository'

interface WalletsState {
    momoProviders: MomoProvider[]
    wallets: Wallet[]
}

const initialState: WalletsState = {
    momoProviders: [],
    wallets: [],
}

export const walletsSlice = createSlice({
    name: 'wallets',
    initialState,
    reducers: {
        setMomoProviders: (state, action: PayloadAction<MomoProvider[]>) => {
            state.momoProviders = action.payload ?? state.momoProviders
        },
        setWallets: (state, action: PayloadAction<Wallet[]>) => {
            state.wallets = action.payload ?? state.wallets
        },
        resetState: state => {
            state.wallets = initialState.wallets
        },
    },
})

export const walletsActions = walletsSlice.actions
export type WalletsActions = typeof walletsSlice.actions
export default walletsSlice.reducer
